import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È cartaceo o digitale?',
  a: 'È un prodotto 100% digitale in formato PDF ad alta risoluzione, ottimizzato per laptop, tablet, smartphone e iPad — così puoi consultarlo ovunque, anche direttamente in sala durante le tue sessioni.'
}, {
  q: 'È adatto a insegnanti principianti?',
  a: 'Sì. Il sistema è progettato sia per insegnanti alle prime armi che per professioniste con esperienza. Parte dai fondamenti e ti accompagna passo dopo passo, senza dare nulla per scontato.'
}, {
  q: 'Posso usarlo con allieve individuali e con gruppi?',
  a: 'Assolutamente. I programmi e i template funzionano sia per sessioni individuali che per lezioni di gruppo, e si adattano facilmente al numero di allieve.'
}, {
  q: 'Include programmi per diversi livelli di danza?',
  a: 'Sì. Il sistema include framework per principianti, livello intermedio, danza espressiva, fitness dance e programmi di trasformazione corporea.'
}, {
  q: 'Quanto velocemente vedrò i risultati?',
  a: 'La maggior parte delle insegnanti riferisce di risparmiare diverse ore di pianificazione già nella prima settimana di utilizzo, grazie alle routine pronte e ai template di sessione.'
}, {
  q: 'Funziona per qualsiasi stile di danza?',
  a: 'Sì. I framework di sessione, le tecniche e i template di programmazione sono pensati per adattarsi a stili diversi — dalla danza espressiva alla fitness dance, fino alla tonificazione e al benessere corporeo.'
}, {
  q: 'I 5 bonus premium sono inclusi subito?',
  a: 'Sì! Tutti e 5 i bonus premium sono inclusi con il tuo acquisto di oggi e ti vengono consegnati istantaneamente insieme al sistema principale.'
}, {
  q: 'È un pagamento unico o un abbonamento?',
  a: "È un pagamento unico di €27. Ottieni accesso a vita all'intero sistema DANZA READY™ e a tutti i bonus, senza alcun costo ricorrente."
}, {
  q: "Come ricevo l'accesso dopo l'acquisto?",
  a: "L'accesso è immediato: subito dopo il pagamento riceverai tutto il materiale via email, pronto da scaricare e usare nella tua prossima sessione."
}, {
  q: 'Come funziona il rimborso se non sono soddisfatta?',
  a: "Ti basta scriverci entro 7 giorni dall'acquisto e ti rimborseremo il 100% del denaro, senza fare domande. Il tuo investimento è totalmente privo di rischi."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-34">
      <div className="text-center mb-4" data-id="element-35">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-36">
          DOMANDE FREQUENTI
        </h2>
      </div>

      <div className="flex flex-col gap-1.5" data-id="element-37">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-cream border border-brand-beige rounded overflow-hidden shadow-sm" data-id="element-38">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-3 py-2.5 text-left flex justify-between items-center hover:bg-brand-beige/30 transition-colors gap-2" data-id="element-39">
              <span className="font-bold text-brand-taupe text-xs sm:text-sm leading-tight" data-id="element-40">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-4 h-4 text-brand-rose transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-41" />
            </button>

            {openIndex === i && <div className="px-3 pb-2.5 pt-0 text-brand-taupe/80 font-medium text-xs sm:text-sm leading-tight" data-id="element-42">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}